// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class WorkflowModel {
    static getAttributeTypeMap() {
        return WorkflowModel.attributeTypeMap;
    }
}
WorkflowModel.discriminator = undefined;
WorkflowModel.additionalProperties = false;
WorkflowModel.attributeTypeMap = [
    {
        "name": "caseWorkflow",
        "baseName": "caseWorkflow",
        "type": "CaseWorkflowModel"
    },
    {
        "name": "payors",
        "baseName": "payors",
        "type": ""
    },
    {
        "name": "prescribers",
        "baseName": "prescribers",
        "type": ""
    },
    {
        "name": "pharmacies",
        "baseName": "pharmacies",
        "type": ""
    },
];
//# sourceMappingURL=workflowModel.js.map